import { client } from './API';

export function fetchEnvironmentPreferences() {
  return client
    .get(`/api/environment-preferences`)
    .then(response => response.data);
}
